import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import api from '../../utils/api';
import { toast } from 'react-toastify';


export const getAllManufacturersThunk = createAsyncThunk(
  'manufacturer/getAllManufacturer',
  async (config, { rejectWithValue }) => {
    try {
      const response = await api.getAllmanufacturer(config);

      return response.data;
    } catch (error) {
      console.log(error);
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);



export const exportManufacturerThunk = createAsyncThunk(
  'manufacturer/exportManufacturer',
  async (config, { rejectWithValue, dispatch }) => {
    try {
      const response = await api.exportManufacturer(config);
      dispatch(setExportedData(response.data?.data))
      return response.data
    } catch (error) {
      console.log(error);
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);




export const deleteManufacturerThunk = createAsyncThunk(
  'manufacturer/deleteManufacturer',
  async (id, { rejectWithValue, dispatch }) => {
    try {

      const response = await api.deleteManufacturer(id);
      dispatch(setManufacturerRefresh())
      toast.success(response.data?.data?.message || 'Data deleted successfully')
      return response.data?.data;

    } catch (error) {
      console.log(error);
      toast.error(error?.response?.data?.message || "something went wrong")
    }
  }
);


export const updateManufacturerThunk = createAsyncThunk(
  'manufacturer/updateManufacturer',
  async (categoryData, { rejectWithValue }) => {
    try {
      const { data, status } = await api.updateManufacturer(categoryData);
      toast.success(data?.data?.message)
      return status
    } catch (error) {
      console.log(error);
      toast.error(error?.response?.data?.message || 'something went wrong')

      return rejectWithValue(error.response.data);
    }
  }
);


export const deletemultipleManufacturer = createAsyncThunk(
  'categories/deletemultipleManufacturer',
  async (id, { rejectWithValue, dispatch }) => {
    try {

      const response = await api.deletemultipleManufacturer(id);
      dispatch(setManufacturerRefresh())
      dispatch(setSelectedmanufacturerids([]))
      dispatch(setSelectallmanufacturer(false))
      toast.success(response.data?.data?.message || 'Data deleted successfully')
      return response.data?.data;

    } catch (error) {
      console.log(error);
      toast.error(error?.response?.data?.message || "something went wrong")
    }
  }
);

const manufacturersSlice = createSlice({
  name: 'manufacturer',
  initialState: {
    manufacturer: [],
    loading: false,
    error: null,
    refresh: false,
    editManufacturer: null,
    exportedData: [],
    exportLoading: false,
    page:1,
    selectedIds:[],
    selectAll:false
  },
  reducers: {
    setManufacturerRefresh: (state, action) => {
      state.refresh = !state.refresh
    },
    setEditManufacturer: (state, action) => {
      state.editManufacturer = action.payload;
    },
    setExportedData: (state, action) => {
      state.exportedData = action.payload;
    },
    setManufacturerPage:(state,action)=>{
      state.page = action.payload
    },
    setSelectedmanufacturerids:(state,action)=>{
      state.selectedIds = action.payload
    },
    setSelectallmanufacturer:(state,action) =>{
      state.selectAll = action.payload
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllManufacturersThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllManufacturersThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.manufacturer = action.payload;
      })
      .addCase(getAllManufacturersThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      //delete
      .addCase(deleteManufacturerThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteManufacturerThunk.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(deleteManufacturerThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      //update
      .addCase(updateManufacturerThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateManufacturerThunk.fulfilled, (state, action) => {
        state.loading = false;

        state.editManufacturer = null;
      })
      .addCase(updateManufacturerThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

       //export manufacturer
       .addCase(exportManufacturerThunk.pending, (state) => {
        state.exportLoading = true;
      })
      .addCase(exportManufacturerThunk.fulfilled, (state, action) => {
        state.exportLoading = false;
        state.exportedData = action.payload
      })
      .addCase(exportManufacturerThunk.rejected, (state, action) => {
        state.exportLoading = false;
      })
  },
});

export const { setManufacturerRefresh, setEditManufacturer, setExportedData,setManufacturerPage,setSelectedmanufacturerids,setSelectallmanufacturer } = manufacturersSlice.actions
export default manufacturersSlice.reducer;

